// Language detection + persistence helpers (framework-agnostic, no React).
// Kept separate from the React context so non-React modules (e.g. the axios
// client) can read the initial language without importing React.

import { SUPPORTED_LANGS } from '@/i18n/translations';

export { translations, SUPPORTED_LANGS } from '@/i18n/translations';

export const LANG_STORAGE_KEY = 'llos_lang';

const normalize = (value) => {
  if (!value) return null;
  const lower = String(value).toLowerCase();
  if (lower.startsWith('pl')) return 'pl';
  if (lower.startsWith('en')) return 'en';
  if (lower.startsWith('vi')) return 'vi';
  return null;
};

// Browser-language auto-detection is intentionally limited to PL/EN (unchanged
// first-visit behaviour). Vietnamese becomes active only when the user selects it.
const AUTO_DETECT_LANGS = ['pl', 'en'];

// Resolve the initial language: saved preference → browser language (PL/EN) → English.
export const detectInitialLang = () => {
  try {
    const saved = normalize(localStorage.getItem(LANG_STORAGE_KEY));
    if (saved && SUPPORTED_LANGS.includes(saved)) return saved;
  } catch {
    // localStorage may be unavailable (private mode); fall through to detection.
  }
  try {
    const nav = normalize(navigator.language || (navigator.languages || [])[0]);
    if (nav && AUTO_DETECT_LANGS.includes(nav)) return nav;
  } catch {
    // navigator may be unavailable; default below.
  }
  return 'en';
};

export const saveLang = (lang) => {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch {
    // Persistence is best-effort; ignore storage failures.
  }
};
